import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { toast } from "sonner";
import { Car, Lock, LogIn } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!credentials.email || !credentials.password) {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_email', response.data.email);
      
      toast.success("Connexion réussie");
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error("Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#000091] rounded-xl flex items-center justify-center mx-auto mb-4">
            <Car className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#0F172A]">Carte Grise Étrangère</h1>
          <p className="text-slate-500">Espace Administration</p>
        </div>

        <Card className="border-slate-200" data-testid="admin-login-card">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-[#0F172A]">
              <Lock className="w-5 h-5 text-[#000091]" />
              Connexion
            </CardTitle>
            <CardDescription>
              Accédez au tableau de bord pour gérer les dossiers
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={credentials.email}
                  onChange={(e) => setCredentials(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="admin@cartegrise.fr"
                  data-testid="admin-email-input"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="password">Mot de passe</Label>
                <Input
                  id="password"
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials(prev => ({ ...prev, password: e.target.value }))}
                  placeholder="••••••••"
                  data-testid="admin-password-input"
                />
              </div>

              <Button 
                type="submit"
                disabled={loading}
                className="w-full bg-[#000091] hover:bg-[#000091]/90"
                data-testid="admin-login-btn"
              >
                {loading ? "Connexion..." : (
                  <>
                    <LogIn className="w-4 h-4 mr-2" />
                    Se connecter
                  </>
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <a 
                href="/" 
                className="text-sm text-[#000091] hover:underline"
              >
                ← Retour au site
              </a>
            </div>
          </CardContent>
        </Card>

        {/* Demo credentials hint */}
        <div className="mt-4 text-center text-xs text-slate-400">
          Demo: admin@cartegrise.fr / admin123
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
